export default "__VITE_ASSET__Dyd$uB_O__"